import { TableHeaderCategoryConfig } from "../../../components/tables/tableContext/TableContext";
import { UnreceivedGoodsDataInterface } from "../../../redux/interfaces/receipt.interface";
import { dateToString } from "../../../utils/dateAndTime";

export const unreceivedGoodsTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Furnizor",
    value: "furnizor",
    minW: 125,
    withSearch: { withoutSearchIcon: true },
  },
  {
    label: "Nr. auto",
    value: "nrAuto",
    minW: 125,
    withSearch: { withoutSearchIcon: true },
  },
  { label: "Bon temperatură", value: "bonTemperatura", minW: 22 },
  {
    label: "Data desc",
    value: "dataDesc",
    minW: 125,
  },
  { label: "Nr. Paleți", value: "nrPaleti", minW: 16 },
  { label: "Nr. Colete", value: "nrColete", minW: 16 },
  {
    label: "Factura",
    value: "factura",
    minW: 125,
    withSearch: { withoutSearchIcon: true },
  },
  {
    label: "Data factură",
    value: "dataFactura",
    minW: 125,
    withDatePicker: {
      maxDate: new Date(),
      withClearData: true,
    },
  },
  { label: "User", value: "user", minW: 20 },
  { label: "Observații", value: "observatii", minW: 28 },
];

export const getUnreceivedGoodsTableData = (
  rows: UnreceivedGoodsDataInterface[],
): any =>
  rows?.map((item) => {
    const invoices = Array.isArray(item.invoices) ? item.invoices : [];

    return {
      id: item.idUnreceivedGoods,
      crudData: item,
      data: [
        { title: item.furnizor ?? "-" },
        { title: item.nrAuto ?? "-" },
        { title: Number(item.bonTemperatura) ? "Da" : "Nu" },
        { title: dateToString(item.dataDesc) },
        { title: item.nrPaleti ?? "-" },
        { title: item.nrColete ?? "-" },
        {
          badges: invoices.map((inv) => ({
            badgeText: inv?.factura ?? "-",
            badgeColor: "secondary",
          })),
        },
        {
          badges: invoices.map((inv) => ({
            badgeText: dateToString(inv?.dataFactura),
            badgeColor: "secondary",
          })),
        },
        { title: item.user ?? "-" },
        { title: item.observatii ?? "-" },
      ],
    };
  });
